module.exports = __webpack_public_path__ + "static/img/mo_btn1.72919e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/mo_btn1.png
// module id = Bsza
// module chunks = 7